import { Platform } from 'quasar'
import { boot } from 'quasar/wrappers'
import { App } from '@capacitor/app'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'

import sendDeviceToken from '../functions/send-device-token'

export default boot(({ app, store, router }) => {
	if (!Platform.is.capacitor) return

	const handleToken = (token) => {
		if (!token) return

		console.log('[push] token FCM:', token)

		if (store.getters['common/device_token'] !== token) {
			store.dispatch('common/SET_DEVICE_TOKEN', [token])
		}

		sendDeviceToken(token)
	}

	const openMessage = (data) => {
		const message_id = data?.message_id

		if (!message_id) return

		store.dispatch('notifications/SET_MESSAGE_ID', [parseInt(message_id)])

		if (router.currentRoute.value.name !== 'profile') {
			router.push({ name: 'profile', query: { tab: 'inbox' } })
		} else {
			app.config.globalProperties.$mitt.emit('showMessage', parseInt(message_id))
		}
	}

	// Substitui o register() do @capacitor/push-notifications. Nas duas plataformas
	// o getToken() devolve o token do FCM — que e o unico formato que o backend
	// aceita, ja que ele envia por firebase_admin.messaging.send(token=...).
	// Nunca abre o dialogo de permissao: so busca o token quando ja foi concedida.
	const loadTokenIfGranted = async () => {
		try {
			const { receive } = await FirebaseMessaging.checkPermissions()

			if (receive !== 'granted') return

			const { token } = await FirebaseMessaging.getToken()
			handleToken(token)
		} catch (e) {
			// No iOS o getToken() falha se a APNs ainda nao devolveu o token do
			// dispositivo. Nao e fatal: o listener 'tokenReceived' dispara assim que
			// o registro terminar, e o appStateChange tenta de novo no proximo
			// retorno ao primeiro plano.
			console.log('[push] falha ao obter o token FCM:', e)
		}
	}

	// Dispara na rotacao do token e, no iOS, quando o registro na APNs termina
	// depois de um getToken() que falhou.
	FirebaseMessaging.addListener('tokenReceived', (event) => handleToken(event.token))

	FirebaseMessaging.addListener('notificationReceived', (event) => {
		// App em primeiro plano. No iOS o proprio sistema desenha a notificacao por
		// causa do presentationOptions do capacitor.config.json; no Android nada e
		// exibido — decidir aqui o que fazer (badge, toast) e trabalho separado.
		console.log('[push] notificacao recebida em foreground:', event.notification)
	})

	FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
		openMessage(event.notification?.data)
	})

	App.addListener('appStateChange', ({ isActive }) => {
		if (isActive) loadTokenIfGranted()
	})

	FirebaseMessaging.checkPermissions()
		.then(async ({ receive }) => {
			if (receive === 'prompt' || receive === 'prompt-with-rationale') {
				const requested = await FirebaseMessaging.requestPermissions()

				if (requested.receive !== 'granted') return
			} else if (receive !== 'granted') {
				return
			}

			const { token } = await FirebaseMessaging.getToken()
			handleToken(token)
		})
		.catch((e) => console.log('[push] falha no fluxo de permissao:', e))
})
